// extracted by mini-css-extract-plugin
export var blue = "_3f-g";
export var brand = "_3f-c";
export var darkGrey = "_3f-f";
export var disabled = "_3f-6";
export var disabledSubtle = "_3f-7";
export var error = "_3f-8";
export var green = "_3f-h";
export var grey = "_3f-e";
export var icon = "_3f-0";
export var inherit = "_3f-b";
export var lightGrey = "_3f-d";
export var orange = "_3f-j";
export var pink = "_3f-l";
export var primary = "_3f-1";
export var purple = "_3f-m";
export var quaternary = "_3f-4";
export var quinary = "_3f-5";
export var red = "_3f-k";
export var secondary = "_3f-2";
export var success = "_3f-a";
export var tertiary = "_3f-3";
export var warning = "_3f-9";
export var white = "_3f-n";
export var yellow = "_3f-i";